// Generated by Melange

import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__CurrencyView from "../../components/html/CurrencyView.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Date from "../../util/Date.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__HrmEmployeeHrmEvents from "../../components/organisms/Hrm/HrmEmployeeHrmEvents.js";
import * as Buhta_cabinet__HrmEmployeeSalary from "../../components/organisms/Hrm/HrmEmployeeSalary.js";
import * as Buhta_cabinet__HrmEmployeeTaxes from "../../components/organisms/Hrm/HrmEmployeeTaxes.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__PayrollHrm from "../../grpc/PayrollHrm.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function HrmEmployeePage$EmployeePageShimmer(Props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            className: "bg-gray-pale w-14 h-14 rounded-full"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-2"
                                          })
                                    ],
                                    className: "flex items-start justify-between"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            className: "h-5 w-[295px] bg-gray-pale rounded"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "h-5 w-[112px] bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex flex-col gap-1"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-[112px] bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("div", {
                                                            className: "w-4 h-4 bg-gray-pale rounded"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            className: "w-[104px] h-5 bg-gray-pale rounded"
                                                          })
                                                    ],
                                                    className: "flex items-center gap-1"
                                                  })
                                            ],
                                            className: "flex gap-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-[112px] bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-[104px] h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-[112px] bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-[80px] h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-[112px] bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-[104px] h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-[112px] bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-[64px] h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-[112px] bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-[120px] h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-4"
                                          })
                                    ],
                                    className: "flex flex-col gap-1"
                                  })
                            ],
                            className: "flex flex-col w-[343px] p-6 gap-4 rounded-md border border-gray-main bg-white"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            className: "w-16 bg-gray-pale rounded h-5 pb-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-12 bg-gray-pale rounded h-5 pb-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-32 bg-gray-pale rounded h-5 pb-2"
                                          })
                                    ],
                                    className: "flex gap-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("hr", {
                                            className: "w-16 h-[1px] bg-links"
                                          }),
                                      JsxRuntime.jsx("hr", {
                                            className: "w-[279px] bg-gray-main"
                                          })
                                    ],
                                    className: "flex justify-between"
                                  })
                            ],
                            className: "flex flex-col gap-2"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            className: "h-5 w-12 bg-gray-pale rounded"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "h-8 w-[150px] bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex flex-col gap-1"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "h-8 w-34 bg-gray-pale rounded"
                                  })
                            ],
                            className: "flex p-4 gap-4 items-center justify-between border border-gray-main rounded-xl"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "h-4 w-30 bg-gray-pale rounded"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            className: "h-8 w-full bg-gray-pale rounded"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "h-8 w-full bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex justify-between gap-4"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-40 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-1 items-center"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "h-5 w-10 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "h-6 w-6 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-1 items-center"
                                          })
                                    ],
                                    className: "flex p-4 gap-4 items-center justify-between border border-gray-main rounded-md"
                                  })
                            ],
                            className: "flex flex-col gap-4 justify-between"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "w-50 h-5 bg-gray-pale rounded mb-3"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-32 h-5 bg-gray-pale rounded mb-1"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-14 h-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-40 h-5 bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex gap-4 items-center justify-between"
                                  }),
                              JsxRuntime.jsx("hr", {
                                    className: "bg-gray-light my-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-50 h-5 bg-gray-pale rounded mb-3"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-32 h-5 bg-gray-pale rounded mb-1"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-14 h-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-40 h-5 bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex gap-4 items-center justify-between"
                                  }),
                              JsxRuntime.jsx("hr", {
                                    className: "bg-gray-light my-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-50 h-5 bg-gray-pale rounded mb-3"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-32 h-5 bg-gray-pale rounded mb-1"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-14 h-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-40 h-5 bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex gap-4 items-center justify-between"
                                  }),
                              JsxRuntime.jsx("hr", {
                                    className: "bg-gray-light my-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-50 h-5 bg-gray-pale rounded mb-3"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-32 h-5 bg-gray-pale rounded mb-1"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-14 h-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-40 h-5 bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex gap-4 items-center justify-between"
                                  }),
                              JsxRuntime.jsx("hr", {
                                    className: "bg-gray-light my-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-50 h-5 bg-gray-pale rounded mb-3"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "w-32 h-5 bg-gray-pale rounded mb-1"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    className: "w-14 h-5 bg-gray-pale rounded"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "w-5 h-5 bg-gray-pale rounded"
                                                  })
                                            ],
                                            className: "flex gap-2"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            className: "w-40 h-5 bg-gray-pale rounded"
                                          })
                                    ],
                                    className: "flex gap-4 items-center justify-between"
                                  })
                            ],
                            className: "flex flex-col p-4 justify-between border border-gray-main rounded-md"
                          })
                    ],
                    className: "flex flex-col gap-6 mx-4 my-6"
                  })
            });
}

const EmployeePageShimmer = {
  make: HrmEmployeePage$EmployeePageShimmer
};

const emptyInfo = Curry.app(Buhta_cabinet__PayrollHrm.EmploymentInfo.make, [
      undefined,
      undefined,
      undefined,
      undefined,
      "Сотрудник",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined
    ]);

function make(org) {
  return function (id) {
    return function (openMenu) {
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = React.useState(function () {
            return 2;
          });
      const setTab = match$1[1];
      const tab = match$1[0];
      const match$2 = React.useState(function () {
            return false;
          });
      const setShowHrmEvents = match$2[1];
      const showHrmEvents = match$2[0];
      const match$3 = React.useState(function () {
            return false;
          });
      const setIsModalShown = match$3[1];
      const match$4 = React.useState(function () {
            return "";
          });
      const setHrmEvent = match$4[1];
      const match$5 = React.useState(function () {
            return 1;
          });
      const refresh = match$5[0];
      const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
      const deviceType = state.deviceType;
      const contextRoute = function (route) {
        return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
      };
      const func = Buhta_cabinet__PayrollHrm.EmployeeService.view;
      const match$6 = Buhta_core__GrpcState.useModel((function (param) {
              return Curry._3(func, param, /* [] */0, id);
            }), undefined);
      const dispatch = match$6[1];
      const model = match$6[0];
      React.useEffect((function () {
              Curry._2(dispatch, undefined, undefined);
            }), [
            id,
            refresh
          ]);
      const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
                  TAG: /* Hrm */5,
                  _0: /* Employees */{
                    _0: /* Index */0
                  }
                }),
            children: JsxRuntime.jsx("img", {
                  className: "w-5 h-5",
                  src: StaticAsset.src("/static/icons/back-arrow.svg")
                })
          });
      const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
              title: "Сотрудник",
              leftChildren: backButton,
              openMenu: openMenu
            }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
              title: "Сотрудник",
              route: contextRoute({
                    TAG: /* Hrm */5,
                    _0: /* Employees */{
                      _0: /* Index */0
                    }
                  })
            });
      let tmp;
      if (typeof model === "string") {
        tmp = model === "Loading" ? JsxRuntime.jsx(HrmEmployeePage$EmployeePageShimmer, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
      } else if (model.NAME === "Data") {
        const employee = model.VAL;
        const fullName = Stdlib__String.concat(" ", {
              hd: employee.family_name,
              tl: {
                hd: employee.given_name,
                tl: {
                  hd: employee.patronymic_name,
                  tl: /* [] */0
                }
              }
            });
        const employment = employee.employment;
        const employment$1 = employment !== undefined ? employment : Curry._8(Buhta_cabinet__PayrollHrm.Employment.make, undefined, undefined, undefined, undefined, emptyInfo, undefined, undefined, undefined);
        const match$7 = employee.employment;
        let info;
        if (match$7 !== undefined) {
          const info$1 = match$7.info;
          info = info$1 !== undefined ? info$1 : emptyInfo;
        } else {
          info = emptyInfo;
        }
        const status = employment$1.status;
        const date = employee.birthday_date;
        let tmp$1;
        switch (status) {
          case /* EMPLOYMENT_STATUS_UNSPECIFIED */0 :
              tmp$1 = JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "w-[64px] h-[64px]",
                            alt: "hrm",
                            src: StaticAsset.src("/static/icons/hrm-events.svg")
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                    className: "font-semibold",
                                    children: "Пользователь пока что не принят на работу"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-asphalt",
                                    children: "Оформите пользователя как сотрудника, чтобы платить за него налоги и добавлять события"
                                  })
                            ],
                            className: "flex flex-col gap-2 w-[408px]"
                          }),
                      JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                            size: "m",
                            kind: "default",
                            className: "flex gap-2 items-center h-[40px]",
                            onClick: (function (param) {
                                Curry._1(setIsModalShown, (function (param) {
                                        return true;
                                      }));
                                Curry._1(setHrmEvent, (function (param) {
                                        return "START";
                                      }));
                              }),
                            children: [
                              "Принять на работу",
                              JsxRuntime.jsx("img", {
                                    src: StaticAsset.src("/static/icons/add-employee.svg")
                                  })
                            ]
                          })
                    ],
                    className: "flex gap-4 bg-gray-pale p-4 items-center"
                  });
              break;
          case /* EMPLOYMENT_STATUS_ACTIVE */1 :
              const match$8 = info.employment_type;
              let tmp$2;
              switch (match$8) {
                case /* EMPLOYMENT_TYPE_UNSPECIFIED */0 :
                    tmp$2 = "—";
                    break;
                case /* EMPLOYMENT_TYPE_SALARY */1 :
                    tmp$2 = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          children: "Трудовой договор"
                        });
                    break;
                case /* EMPLOYMENT_TYPE_CONTRACT */2 :
                    tmp$2 = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          children: "ГПХ"
                        });
                    break;
                
              }
              const rate = info.salary_rate;
              const date$1 = employment$1.start_date;
              tmp$1 = JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-6 h-6",
                                            alt: "employee",
                                            src: StaticAsset.src("/static/icons/employee.svg")
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt",
                                                    children: "Должность"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: info.position
                                                  })
                                            ],
                                            className: "flex flex-col gap-1 "
                                          })
                                    ],
                                    className: "flex items-start gap-4 w-[343px]"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-6 h-6",
                                            alt: "employee",
                                            src: StaticAsset.src("/static/icons/employee-type.svg")
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt",
                                                    children: "Тип сотрудника"
                                                  }),
                                              tmp$2
                                            ],
                                            className: "flex flex-col gap-1"
                                          })
                                    ],
                                    className: "flex items-start gap-4 w-[343px]"
                                  })
                            ],
                            className: "flex justify-between items-center"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-6 h-6",
                                            alt: "employee",
                                            src: StaticAsset.src("/static/icons/cash-gray.svg")
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt",
                                                    children: "Зарплата"
                                                  }),
                                              rate !== undefined ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "border-r border-gray-main pr-2",
                                                              children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                                    amount: Caml_format.caml_float_of_string(rate)
                                                                  })
                                                            }),
                                                        info.gross_method ? JsxRuntime.jsxs(React.Fragment, {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "border-r border-gray-main px-2",
                                                                        children: "На руки"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "pl-2",
                                                                        children: "От обратного"
                                                                      })
                                                                ]
                                                              }) : JsxRuntime.jsxs(React.Fragment, {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "border-r border-gray-main px-2",
                                                                        children: "C налогами"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "pl-2",
                                                                        children: "Прямой расчет"
                                                                      })
                                                                ]
                                                              })
                                                      ],
                                                      className: "flex"
                                                    }) : "—"
                                            ],
                                            className: "flex flex-col gap-1 "
                                          })
                                    ],
                                    className: "flex items-start gap-4 w-[343px]"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-6 h-6",
                                            alt: "employee",
                                            src: StaticAsset.src("/static/icons/calendar.svg")
                                          }),
                                      date$1 !== undefined ? JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "text-asphalt",
                                                      children: "Работает с"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            children: Buhta_cabinet__Date.toString(date$1)
                                                          }),
                                                      className: "flex gap-2"
                                                    })
                                              ],
                                              className: "flex flex-col gap-1"
                                            }) : "—"
                                    ],
                                    className: "flex items-start gap-4 w-[343px]"
                                  })
                            ],
                            className: "mt-4 flex justify-between items-center"
                          }),
                      JsxRuntime.jsx("hr", {
                            className: "my-4 bg-gray-light"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                            size: "s",
                                            kind: "default",
                                            className: "flex items-center gap-1 px-[12px] py-[8px]",
                                            onClick: (function (param) {
                                                Curry._1(setIsModalShown, (function (param) {
                                                        return true;
                                                      }));
                                                Curry._1(setHrmEvent, (function (param) {
                                                        return "CHANGE";
                                                      }));
                                              }),
                                            children: [
                                              "Изменить",
                                              JsxRuntime.jsx("img", {
                                                    alt: "employee-edit",
                                                    src: StaticAsset.src("/static/icons/employee-edit.svg")
                                                  })
                                            ]
                                          }),
                                      JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                            size: "s",
                                            kind: "default",
                                            className: "flex items-center gap-1 px-[12px] py-[8px]",
                                            onClick: (function (param) {
                                                Curry._1(setIsModalShown, (function (param) {
                                                        return true;
                                                      }));
                                                Curry._1(setHrmEvent, (function (param) {
                                                        return "TERMINATION";
                                                      }));
                                              }),
                                            children: [
                                              "Уволить",
                                              JsxRuntime.jsx("img", {
                                                    alt: "employee-remove",
                                                    src: StaticAsset.src("/static/icons/employee-remove.svg")
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-center gap-2"
                                  }),
                              JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                    size: "s",
                                    kind: "default",
                                    className: "flex items-center gap-1 px-[12px] py-[8px]",
                                    onClick: (function (param) {
                                        Curry._1(setShowHrmEvents, (function (param) {
                                                return !showHrmEvents;
                                              }));
                                      }),
                                    children: [
                                      "Кадровые события",
                                      JsxRuntime.jsx("img", {
                                            alt: "smena",
                                            src: StaticAsset.src("/static/icons/smena.svg")
                                          })
                                    ]
                                  })
                            ],
                            className: "flex items-center justify-between"
                          }),
                      showHrmEvents ? JsxRuntime.jsx(Buhta_cabinet__HrmEmployeeHrmEvents.make, {
                              org: org,
                              employee: employee,
                              employeeId: id
                            }) : null
                    ]
                  });
              break;
          case /* EMPLOYMENT_STATUS_TERMINATED */2 :
              tmp$1 = JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "w-[64px] h-[64px]",
                            alt: "hrm",
                            src: StaticAsset.src("/static/icons/hrm-events.svg")
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                    className: "font-semibold",
                                    children: "Сотрудник уволен"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-asphalt",
                                    children: "Оформите пользователя как сотрудника, чтобы платить за него налоги и добавлять события"
                                  })
                            ],
                            className: "flex flex-col gap-2 w-[408px]"
                          }),
                      JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                            size: "m",
                            kind: "default",
                            className: "flex gap-2 items-center h-[40px]",
                            onClick: (function (param) {
                                Curry._1(setIsModalShown, (function (param) {
                                        return true;
                                      }));
                                Curry._1(setHrmEvent, (function (param) {
                                        return "START";
                                      }));
                              }),
                            children: [
                              "Принять на работу",
                              JsxRuntime.jsx("img", {
                                    src: StaticAsset.src("/static/icons/add-employee.svg")
                                  })
                            ]
                          })
                    ],
                    className: "flex gap-4 bg-gray-pale p-4 items-center"
                  });
              break;
          
        }
        tmp = JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("img", {
                                                                className: "h-6 w-6",
                                                                src: StaticAsset.src("/static/icons/user.svg")
                                                              }),
                                                          className: "w-[72px] h-[108px] flex flex-col justify-center items-center bg-gray-pale rounded"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx(Buhta_components__Text.PLarge.make, {
                                                                  className: "font-semibold",
                                                                  children: fullName
                                                                }),
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                          className: "w-30 text-default-gray",
                                                                          children: "Телефон"
                                                                        }),
                                                                    JsxRuntime.jsxs("div", {
                                                                          children: [
                                                                            JsxRuntime.jsx("img", {
                                                                                  className: "w-4 h-4",
                                                                                  src: StaticAsset.src("/static/icons/done-16.svg")
                                                                                }),
                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                  className: "ml-1 text-black",
                                                                                  children: Formating.formatPhone(employee.phone)
                                                                                })
                                                                          ],
                                                                          className: "ml-4 flex items-center"
                                                                        })
                                                                  ],
                                                                  className: "flex mt-3"
                                                                }),
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                          className: "w-30 text-default-gray",
                                                                          children: "ИИН"
                                                                        }),
                                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                          className: "ml-4 text-black",
                                                                          children: employee.tin
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                          className: "w-30 text-default-gray",
                                                                          children: "Дата рождения"
                                                                        }),
                                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                          className: "ml-4 text-black",
                                                                          children: date !== undefined ? Buhta_cabinet__Date.toString(date) : "—"
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                })
                                                          ],
                                                          className: "flex flex-col gap-1"
                                                        })
                                                  ],
                                                  className: "flex gap-4"
                                                }),
                                            JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                                                  route: contextRoute({
                                                        TAG: /* Hrm */5,
                                                        _0: /* Employees */{
                                                          _0: {
                                                            TAG: /* Edit */1,
                                                            _0: employee.id
                                                          }
                                                        }
                                                      }),
                                                  className: "flex md:border md:border-gray-main rounded-md px-3 py-2",
                                                  children: [
                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          className: "hidden md:block mr-1 font-semibold",
                                                          children: "Редактировать"
                                                        }),
                                                    JsxRuntime.jsx("img", {
                                                          src: StaticAsset.src("/static/icons/edit-20.svg")
                                                        })
                                                  ]
                                                })
                                          ],
                                          className: "flex flex-col md:flex-row w-full justify-between items-start md:gap-4"
                                        })
                                  }),
                              className: "border border-gray-main rounded-md p-6"
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp$1,
                              className: "border border-gray-main rounded-md w-[343px] md:w-[758px] p-4 mt-4"
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("a", {
                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: Cn.fromList({
                                        hd: "text-center",
                                        tl: {
                                          hd: tab === 2 ? "text-links" : "text-gray-medium",
                                          tl: /* [] */0
                                        }
                                      }),
                                  children: "Налоги"
                                }),
                            className: Cn.fromList({
                                  hd: "py-2.5 grow lg:grow-0 cursor-pointer",
                                  tl: {
                                    hd: Cn.on("border-b border-links", tab === 2),
                                    tl: /* [] */0
                                  }
                                }),
                            onClick: (function (param) {
                                Curry._1(setTab, (function (param) {
                                        return 2;
                                      }));
                              })
                          }),
                      className: "bg-white min-w-[343px] md:w-[758px] border-b border-gray-main flex lg:gap-6 mt-6"
                    }),
                tab !== 1 ? (
                    tab !== 2 ? null : JsxRuntime.jsx(Buhta_cabinet__HrmEmployeeTaxes.make, {})
                  ) : JsxRuntime.jsx(Buhta_cabinet__HrmEmployeeSalary.make, {
                        status: status
                      }),
                JsxRuntime.jsx(Buhta_cabinet__HrmEmployeeHrmEvents.make, {
                      org: org,
                      employee: employee,
                      employeeId: id,
                      isModalShown: match$3[0],
                      setIsModalShown: setIsModalShown,
                      hrmEvent: match$4[0],
                      setHrmEvent: setHrmEvent,
                      showEventsHistory: false,
                      refresh: refresh,
                      setRefresh: match$5[1]
                    })
              ]
            });
      } else {
        tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
      }
      return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                  header: header,
                  children: tmp,
                  className: "px-4 py-6 md:py-10 md:px-0 flex-col items-center"
                });
    };
  };
}

function HrmEmployeePage(Props) {
  return Curry._1(make(Props.org)(Props.id), Props.openMenu);
}

const make$1 = HrmEmployeePage;

export {
  EmployeePageShimmer ,
  emptyInfo ,
  make$1 as make,
}
/* emptyInfo Not a pure module */
